import { MomentDateAdapter } from "@angular/material-moment-adapter";
import moment from "moment";

export class CustomMomentDateAdapter extends MomentDateAdapter {
     /* istanbul ignore next */
    constructor(matDateLocale: string) {
      super(matDateLocale);
    }
  
    // Override the parse method to handle different formats
      /* istanbul ignore next */
    override parse(value: any, parseFormat: string | string[]): moment.Moment | null {
      if (value && typeof value === 'string') {
        const numericInputPattern = /^\d{8}$/; // Match 'MMDDYYYY' format
        const dateWithDashesPattern = /^\d{2}-\d{2}-\d{4}$/; // Match 'MM-DD-YYYY' format
        const dateWithSlashesPattern = /^\d{2}\/\d{2}\/\d{4}$/; // Match 'MM/DD/YYYY' format
  
        // If input matches 'MMDDYYYY', convert it to 'MM-DD-YYYY'
        if (numericInputPattern.test(value)) {
          const month = value.substring(0, 2);
          const day = value.substring(2, 4);
          const year = value.substring(4, 8);
          const formattedValue = `${month}-${day}-${year}`;
          return moment(formattedValue, 'MM-DD-YYYY', true); // Parse as 'MM-DD-YYYY'
        }
  
        // If input matches 'MM-DD-YYYY' or 'MM/DD/YYYY', parse directly
        if (dateWithDashesPattern.test(value) || dateWithSlashesPattern.test(value)) {
          return moment(value, ['MM-DD-YYYY', 'MM/DD/YYYY'], true); // Strictly parse both formats
        }
  
        // Default to Moment.js parsing if it doesn't match known patterns
        return moment(value, parseFormat, true); // Strict parsing for other formats
      }
      return super.parse(value, parseFormat);
    }
  }